import React, { useContext } from "react";
import "./EscapeRoomTile.css";
import { faEuroSign, faClock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

import { AppContext } from "../../shared/context/AppContext";

// A real link, so it works with the keyboard, middle-click and "open in new tab"
function EscapeRoomTile({
  title,
  titleEN,
  estTime,
  price,
  linkto,
  live,
  gifName,
  picName,
  dutch,
  english,
}) {
  const { language } = useContext(AppContext);
  const nl = language === "NL";
  const name = nl ? title : titleEN;

  const content = (
    <>
      <div className="ERpicture">
        <img
          alt=""
          className="static-tile-img"
          src={require(`../img/${picName}`).default}
        />
        {/* Only fetched once hovered, see the CSS */}
        <img
          alt=""
          className="gif-tile-img"
          loading="lazy"
          src={require(`../img/${gifName}`).default}
        />
        {!live && (
          <span className="ER-badge">
            {nl ? "Binnenkort" : "Coming soon"}
          </span>
        )}
        {live && price === 0 && (
          <span className="ER-badge">{nl ? "Gratis" : "Free"}</span>
        )}
      </div>
      <div className="ERbody">
        <h2 className="escaperoom-card-title">{name}</h2>
        <ul className="ERinfo">
          <li className="infoItem">
            <FontAwesomeIcon icon={faClock} /> {estTime}{" "}
            min
          </li>
          <li className="infoItem">
            <FontAwesomeIcon icon={faEuroSign} />
            {price > 0 ? `${price} / team` : nl ? "Gratis" : "Free"}
          </li>
          <li className="infoItem languages">
            {dutch && <abbr title={nl ? "Nederlands" : "Dutch"}>NL</abbr>}
            {english && <abbr title={nl ? "Engels" : "English"}>EN</abbr>}
          </li>
        </ul>
      </div>
    </>
  );

  return (
    <li className="EscapeRoomTile">
      {live ? (
        <Link className="innerERtile" to={`/escaperooms/info/${linkto}`}>
          {content}
        </Link>
      ) : (
        <div className="innerERtile inactive">{content}</div>
      )}
    </li>
  );
}

export default EscapeRoomTile;
